import axios, { AxiosInstance } from "axios";
import { installAxiosCryptoInterceptor } from "./utils/apiCrypto";

let baseURL = null;
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
) {
  baseURL = "http://127.0.0.1:3055/api/v1/";
} else if (
  window.location.hostname === "www.transparencia.anastacio.ms.gov.br" ||
  window.location.hostname === "transparencia.anastacio.ms.gov.br"
) {
  baseURL = "https://server.anastacio.ms.gov.br/api/v1/";
} else {
  baseURL = "https://api.anastacio.sistemaweb.com.br/api/v1/";
}

const Api: AxiosInstance = axios.create({
  baseURL,
});

installAxiosCryptoInterceptor(Api);

export default Api;
